// src/components/battle/BattleDateInput.jsx
export default function BattleDateInput({ value, onChange }) {
  return (
    <div className="mb-4 text-sm">
      <label className="block mb-2 font-medium">
        대결일시
      </label>

      <input
        type="datetime-local"
        className="
          w-full
          rounded-xl
          border border-slate-200
          bg-gray-50
          px-4 py-3
          text-sm
          outline-none
          placeholder:text-slate-400
          focus:border-[rgb(0,224,198)]
          focus:ring-2
          focus:ring-[rgb(0,224,198)]/20
        "
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

     
    </div>
  );
}
